import { render, staticRenderFns } from "./SelfService.vue?vue&type=template&id=29ca635c&scoped=true"
import script from "./SelfService.vue?vue&type=script&lang=js"
export * from "./SelfService.vue?vue&type=script&lang=js"
import style0 from "./SelfService.vue?vue&type=style&index=0&id=29ca635c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ca635c",
  null
  
)

export default component.exports